import { createGlobalStyle } from 'styled-components';

import SourceSansProRegular from '@/assets/fonts/source-sans-pro-regular.woff';
import BlueTail from '@/assets/icons/cover-images/blue-chat-tail.png';
import GreyTail from '@/assets/icons/cover-images/grey-chat-tail.png';

const VariationStyles = createGlobalStyle`
 @font-face {
     font-family: 'SourceSansProRegular';
     src: url(${SourceSansProRegular});
     font-weight: 400;
     font-style: normal;
   }  
  .generated-images-holder-var42 {
    /* position: absolute; */
    bottom: 100%;
    right: 100%;
    width: 1200px;
    height: 630px;
  }
  .image-holder-var42 {
    height: 100%;
    width: 100%;
    display: flex;
    position: relative;
  }

  .chats-holder-var42 {
    width: 100%;
    height: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;
    gap: 44px;
    justify-content: center;
  }

  .bottom-text-var42 {
    font-family: SourceSansProRegular;
    font-size: 40px;
    padding: 13px 30px;
    display: inline-block;
    margin: 0;
    max-width: calc(100% - 88px);
    border-radius: 10px;
    line-height: 1.2;
    position: relative;
    &:after {
      content: '';
      background: url(${BlueTail}) no-repeat center center;;
      position: absolute;
      bottom: -29px;
      right: 1px;
      width: 60px;
      height: 31px;
    }
    &__blue {
      align-self: flex-end;
      background-color: #0089ff;
      color: white;
      margin-right: 44px;
    }
    &__grey {
      align-self: flex-start;
      background-color: #e7e5ea;
      color: #000;
      margin-left: 44px;
       &:after {
        left: 1px;
        right: auto;
        background: url(${GreyTail}) no-repeat center center;
      }
    }
    &__center {
      align-self: center;
      margin: 0 44px;
    }
  }

  .break-var42 {
    position: absolute;
    width: 12px;
    height: 100%;
    background-color: black;
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    z-index: 1;
  }
  
`;

export default VariationStyles;
